import styled from 'styled-components';
import { AccordionPanelMixin } from '../../mixins/components/AccordionPanelMixin';
export var StyledAccordionPanel = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionPanel",
  componentId: "c11n-8-111-1__sc-1n2fcl1-0"
})(["", ""], AccordionPanelMixin);